<template>
    <div class="d-flex flex-row mb-3 pb-3 border-bottom">
        <router-link tag="a" :to="detailPath">
            <img :src="data.thumb" :alt="data.title" class="img-thumbnail border-0 list-thumbnail align-self-center"/>

        </router-link>
        <div class="pl-3 pr-2">
            <router-link tag="a" :to="detailPath">
                <p class="font-weight-medium mb-0 ">{{ data.title }}</p>
                <!-- <p class="text-muted mb-1 text-small">Store : {{ data.store }}</p> -->
                <p class="mb-1 text-muted text-small">Check In : <b class="dark">08:00 </b>&nbsp;&nbsp;&nbsp;   Check Out : <b class="dark">18:00</b> </p>
                <p class="text-muted mb-1 text-small">Position : PC</p>
                <p class="text-muted mb-1 text-small">Store : {{ data.store }}</p>
                <p class="text-muted mb-1 text-small">Province : {{ data.province }}</p>

                 <b-dropdown id="ddown5" text="1 (ทำงาน)" style="width:100px; float: right; " size="xs" variant="outline-info" class="mr-0 mb-0">
                      <b-dropdown-item>S2 (ลาป่วย)</b-dropdown-item>
                      <b-dropdown-item>S1 (ลากิจ)</b-dropdown-item>
                      <b-dropdown-item>S4 (ไม่มี RO)</b-dropdown-item>
                      <b-dropdown-item>A (ทำชด)</b-dropdown-item>
                      <b-dropdown-item>1 (ทำงาน)</b-dropdown-item>
                  </b-dropdown>&nbsp;
                  <b-dropdown id="ddown5" text="คิดเต็มวัน" style="width:100px; float: right; padding-right:5px;" size="xs" variant="outline-info" class="mr-0 mb-0">
                      <b-dropdown-item value="1">คิดเต็มวัน</b-dropdown-item>
                      <b-dropdown-item value="0.5">ครึ่งวัน</b-dropdown-item>
                      <b-dropdown-item value="0">ไม่คิด</b-dropdown-item>
                  </b-dropdown>

            </router-link>

        </div>
        <!-- <div id="mybutton">
          <div class="d-flex">
            <div style="cursor: pointer;" class="align-self-center list-thumbnail-letters rounded-circle m-2" @click="onSave()" >{{ $t("menu.save")}}</div>
          </div>
        </div> -->

    </div>
</template>
<script>
import vSelect from 'vue-select'
import Stars from '@/components/Common/Stars'
export default {
  components: {
    Stars,
    vSelect
  },
  data () {
    return {
      d1: [
        { value: '01', label: '01' }
      ]
    }
  },
  methods: {

  },
  mounted () {
  },
  props: ['data', 'detailPath']
}
</script>
<style scope>

.btn-group > .btn:first-child {
    margin-left: 0;
    width: 100%;
}
.btn-group > .btn:first-child {
    margin-left: 0;
    width: 100%;
    text-align: left;
}
.dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent;
    text-align: right;
    float: right;
    margin-top: 5px;
}
</style>
